import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import './Footer.css';

const MenuEN = () => (
  <p className="legal">
    <a
      href="https://www.draeger.com/en-us_us/Home/Data-Protection"
      rel="noopener noreferrer"
      target="_blank"
    >
    Data Protection
    </a>
    <a
      href="https://www.draeger.com/en-us_us/Home/Sitemap"
      rel="noopener noreferrer"
      target="_blank"
    >
    Site Map
    </a>
    <a
      href="https://www.draeger.com/en-us_us/Home/Legal-Notices"
      rel="noopener noreferrer"
      target="_blank"
    >
    Legal & Compliance Notices
    </a>
    <a
      href="https://www.draeger.com/en-us_us/Home/Provider-Identification"
      rel="noopener noreferrer"
      target="_blank"
    >
    Provider Identification
    </a>
    <a
      href="https://www.draeger.com/en-us_us/Home/Terms-Conditions"
      rel="noopener noreferrer"
      target="_blank"
    >
    Terms of Sale and Product Returns
    </a>
    <Link to="/licenses">
    Licenses
    </Link>
  </p>
);

const MenuDE = () => (
  <p className="legal">
    <a
      href="https://www.draeger.com/de_de/Home/Data-Protection"
      rel="noopener noreferrer"
      target="_blank"
    >
    Datenschutz
    </a>
    <a
      href="https://www.draeger.com/de_de/Home/Sitemap"
      rel="noopener noreferrer"
      target="_blank"
    >
    Site Map
    </a>
    <a
      href="https://www.draeger.com/de_de/Home/Legal-Notices"
      rel="noopener noreferrer"
      target="_blank"
    >
    Rechtliche Hinweise
    </a>
    <a
      href="https://www.draeger.com/de_de/Home/Provider-Identification"
      rel="noopener noreferrer"
      target="_blank"
    >
    Impressum
    </a>
    <a
      href="https://www.draeger.com/de_de/Home/Terms-Conditions"
      rel="noopener noreferrer"
      target="_blank"
    >
    AGB
    </a>
    <Link to="/licenses">
    Lizenzen
    </Link>
  </p>
);

const MenuES = () => (
  <p className="legal">
      <a
        href="https://www.draeger.com/es_es/Home/Data-Protection"
        rel="noopener noreferrer"
        target="_blank"
      >
          Protección de datos
      </a>
      <a
        href="https://www.draeger.com/es_es/Home/Sitemap"
        rel="noopener noreferrer"
        target="_blank"
      >
          Mapa del sitio
      </a>
      <a
        href="https://www.draeger.com/es_es/Home/Legal-Notices"
        rel="noopener noreferrer"
        target="_blank"
      >
          Notas legales
      </a>
      <a
        href="https://www.draeger.com/es_es/Home/Provider-Identification"
        rel="noopener noreferrer"
        target="_blank"
      >
          Identificación del proveedor
      </a>
      <a
        href="https://www.draeger.com/es_es/Home/Terms-Conditions"
        rel="noopener noreferrer"
        target="_blank"
      >
          AGB
      </a>
      <Link to="/licenses">
          Licencias
      </Link>
  </p>
);

const menus = {
    EN: MenuEN,
    DE: MenuDE,
    ES: MenuES,
};

const Footer = ({ usingLanguage }) => {
  const MenuComponent = menus[usingLanguage];
  return (
    <footer>
      <hr />
      <MenuComponent />
      <hr />
    </footer>
  );
};

Footer.defaultProps = {};
Footer.propTypes = {
  usingLanguage: PropTypes.string.isRequired
};

export default connect(
  state => ({
    usingLanguage: state.strings.usingLanguage
  }),
)(Footer);
